import { useQuery } from "@tanstack/react-query";
import { User } from "@/types/auth";
import {
  OnboardingStatusSnapshot,
  onboardingStatusKey,
  queryOnboardingStatus,
} from "./onboardingGuard";

const STATUS_STALE_MS = 30 * 60 * 1000;

/**
 * Single shared source for the onboarding status. Every guard reads the same
 * cache entry (keyed by uid), so navigating between protected routes reuses one
 * request instead of re-fetching per mount. A local "completed" progress flag
 * provides the answer synchronously without a network call.
 */
export function useOnboardingStatus(user: User | null) {
  const uid = user?.firebase_uid;

  return useQuery<OnboardingStatusSnapshot>({
    queryKey: onboardingStatusKey(uid),
    queryFn: () => queryOnboardingStatus(user!),
    enabled: !!uid,
    staleTime: STATUS_STALE_MS,
    gcTime: 60 * 60 * 1000,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
}
